import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { environment } from 'environment-configurations';
import { Subject } from 'rxjs';
import { getStepDetails } from 'visa-store';
import * as i1$1 from 'primeng/api';
import * as i3 from 'app-services-library';
import * as i5 from 'ngx-toastr';
import * as i6 from 'primeng/dialog';
import * as i7 from 'primeng/radiobutton';
import * as i8 from '@angular/forms';
import * as i9 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class CustomButtonService {
    constructor(http) {
        this.http = http;
    }
    downloadFile(url) {
        return this.http.get(url, { responseType: 'blob' });
    }
    // downloadFile(path: string, fileName) {
    //     this.http.get(path, { responseType: "arraybuffer" })
    //   .pipe(take(1))
    //   .subscribe(pdf => {
    //     const blob = new Blob([pdf], { type: 'application/tar' });
    //     saveAs(blob, fileName);
    //   });
    // }
    getdownloadAllDocuments(path) {
        return this.http.get(path).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
}
CustomButtonService.ɵfac = function CustomButtonService_Factory(t) { return new (t || CustomButtonService)(i0.ɵɵinject(i1.HttpClient)); };
CustomButtonService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomButtonService, factory: CustomButtonService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomButtonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CustomButtonComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4, "Please select ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "strong", 4);
    i0.ɵɵtext(6, "Download Now");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, ", ");
    i0.ɵɵelementStart(8, "span", 4);
    i0.ɵɵtext(9, "if you do not have the efile tracker application installed.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵelementStart(11, "div", 11);
    i0.ɵɵelementStart(12, "label");
    i0.ɵɵelementStart(13, "span", 4);
    i0.ɵɵtext(14, "Please select installed OS in your machine");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 11);
    i0.ɵɵelementStart(16, "p-radioButton", 12);
    i0.ɵɵlistener("ngModelChange", function CustomButtonComponent_ng_template_8_Template_p_radioButton_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.selectedOS = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "label", 13);
    i0.ɵɵtext(18, "Mac / Linux");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "p-radioButton", 14);
    i0.ɵɵlistener("ngModelChange", function CustomButtonComponent_ng_template_8_Template_p_radioButton_ngModelChange_19_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.selectedOS = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "label", 15);
    i0.ɵɵtext(21, "Windows");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(16);
    i0.ɵɵproperty("ngModel", ctx_r1.selectedOS);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r1.selectedOS);
} }
function CustomButtonComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function CustomButtonComponent_ng_template_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.closeDialog(); });
    i0.ɵɵelementStart(1, "span", 4);
    i0.ɵɵtext(2, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 17);
    i0.ɵɵlistener("click", function CustomButtonComponent_ng_template_9_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.performDownload(); });
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5, "Download Now");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "width": a0 }; };
const _c1 = function () { return { width: "50vw" }; };
class CustomButtonComponent {
    constructor(confirmationService, store, appServicesLibraryService, btnApiService, toastr) {
        this.confirmationService = confirmationService;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.btnApiService = btnApiService;
        this.toastr = toastr;
        this.showDownloadInstaller = false;
        this.downloadNow = false;
        this.selectedOS = "windows";
        this.observableSubscription$ = new Subject();
        this.userType = '';
        this.disableBtn = false;
    }
    ngOnInit() {
        //console.log("this.inputParams custom button",this.inputParams);
        // console.log(this.inputData);
        this.userType = sessionStorage.getItem('userTypeRole');
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleInputFields();
            });
        }
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    toggleInputFields() {
        /*  if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
           this.disableBtn = true;
           this.group.disable();
         } else {
           this.disableBtn = false;
           this.group.enable();
         } */
    }
    performAction() {
        var _a, _b, _c;
        //console.log("this.inputParams.actionType",this.inputParams);
        if (this.inputParams.pdfType == "Invoice") {
            // console.log("invoice");
        }
        else if (this.inputParams.pdfType == "Receipt") {
            // console.log("receipt");
        }
        else {
            if ((((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.allowDownloadAllFiles) && ((_b = this.inputParams) === null || _b === void 0 ? void 0 : _b.actionType) !== 'download') ||
                ["I129EFILING", "N400EFILING"].includes((_c = this.inputParams) === null || _c === void 0 ? void 0 : _c.actionType)) {
                let path = `/${this.inputData.visatype}/company/${this.inputData.companyId}/PETITION/${this.inputData.petitionId}/efiling/downloadfiles`;
                this.btnApiService.getdownloadAllDocuments(path)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    if (response) {
                        if (response.data) {
                            const filePath = environment.docs + response.data.message;
                            this.downloadedFile(filePath);
                        }
                        else {
                            this.toastr.success(response.message, 'Success');
                        }
                    }
                });
            }
            switch (this.inputParams.actionType) {
                case 'DS160':
                    window.location.href = 'efile-ds160://';
                    break;
                case 'DS260':
                    window.location.href = 'efile-ds260://';
                    break;
                case 'PERM':
                    alert('PERM');
                    break;
                case 'PWD':
                    window.location.href = 'efile-pwd://';
                    break;
                case 'I130':
                    window.location.href = 'efile-130://';
                    break;
                case 'I129EFILING':
                    window.location.href = 'efile-129://';
                    break;
                case 'N400EFILING':
                    window.location.href = 'efile-n400://';
                    break;
                case 'I131EFILING':
                    window.location.href = 'efile-i131://';
                    break;
                case 'I190EFILING':
                    window.location.href = 'efile-i90://';
                    break;
                case 'I765EFILING':
                    window.location.href = 'efile-i765://';
                    break;
                case 'I589EFILING':
                    window.location.href = 'efile-i589://';
                    break;
                case 'download':
                    this.showDownloadInstaller = true;
                    break;
                default:
                    alert('no action');
                    break;
            }
        }
    }
    performDownload() {
        this.showDownloadInstaller = false;
        switch (this.inputParams.installerType) {
            case 'DS160':
                if (this.selectedOS === 'windows') {
                    window.location.href = './application/DS-160/ds-160.zip';
                }
                else {
                    window.location.href = './application/DS-160/ds-160-Mac.zip';
                }
                break;
            case 'DS260':
                if (this.selectedOS === 'windows') {
                    window.location.href = './application/DS-260/ds-260.zip';
                }
                else {
                    window.location.href = './application/DS-260/ds-260-Mac.zip';
                }
                break;
            case 'PERM':
                alert('DS160');
                break;
            case 'PWD':
                if (this.selectedOS === 'windows') {
                    window.location.href = './application/PWD-Efiling/pwd-efiling.zip';
                }
                else {
                    window.location.href = './application/PWD-Efiling/pwd-efiling.pkg';
                }
                break;
            case 'I130':
                if (this.selectedOS === 'windows') {
                    window.location.href = './application/I130-EFiling/i130-efiling.zip';
                }
                else {
                    window.location.href = './application/I130-EFiling/i130-efiling.pkg';
                }
                break;
            case 'N400EFILING':
                if (this.selectedOS === 'windows') {
                    window.location.href = `${environment.appUrl}/application/N-400/n-400.zip`;
                }
                else {
                    window.location.href = `${environment.appUrl}/application/N-400/n-400.pkg`;
                }
                break;
            case 'I129EFILING':
                if (this.selectedOS === 'windows') {
                    window.location.href = `${environment.appUrl}/application/I129-EFiling/i129-efiling.zip`;
                }
                else {
                    window.location.href = `${environment.appUrl}/application/I129-EFiling/i129-efiling.pkg`;
                }
                break;
            case 'I131EFILING':
                if (this.selectedOS === 'windows') {
                    window.location.href = `${environment.appUrl}/application/I131-EFiling/ImagilityI131.zip`;
                }
                else {
                    window.location.href = `${environment.appUrl}/application/I131-EFiling/ImagilityI131.pkg`;
                }
                break;
            case 'I190EFILING':
                if (this.selectedOS === 'windows') {
                    window.location.href = `${environment.appUrl}/application/I90-EFiling/ImagilityI90.zip`;
                }
                else {
                    window.location.href = `${environment.appUrl}/application/I90-EFiling/ImagilityI90.pkg`;
                }
                break;
            case 'I765EFILING':
                if (this.selectedOS === 'windows') {
                    window.location.href = `${environment.appUrl}/application/I765-EFiling/ImagilityI765.zip`;
                }
                else {
                    window.location.href = `${environment.appUrl}/application/I765-EFiling/ImagilityI765.pkg`;
                }
                break;
            case 'I589EFILING':
                if (this.selectedOS === 'windows') {
                    window.location.href = `${environment.appUrl}/application/I589-EFiling/ImagilityI589.zip`;
                }
                else {
                    window.location.href = `${environment.appUrl}/application/I589-EFiling/ImagilityI589.pkg`;
                }
                break;
            default:
                alert('no action');
                break;
        }
    }
    closeDialog() {
        this.showDownloadInstaller = false;
        this.selectedOS = "windows";
    }
    // getDownloadedFiles(){
    //   this.btnApiService.getEfilingDownloadedFiles()
    //           .subscribe(response => {
    //             // this.setTaskDetails(response);
    //           });
    // }
    // openDownloadPopup(){
    //   this.confirmationService.confirm({
    //     key: 'selectOs',
    //     message: 'Are you sure that you want to perform this action?',
    //     accept: () => {
    //       console.log('here');
    //       console.log(this.selectedOS);
    //         //Actual logic to perform a confirmation
    //     }
    //   });
    // }
    downloadedFile(url) {
        this.btnApiService.downloadFile(url).subscribe((blob) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.inputData.petitionId}.tar`;
            link.click();
        });
        // this.btnApiService.downloadFile(url,'Filesummary')
    }
}
CustomButtonComponent.ɵfac = function CustomButtonComponent_Factory(t) { return new (t || CustomButtonComponent)(i0.ɵɵdirectiveInject(i1$1.ConfirmationService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService), i0.ɵɵdirectiveInject(CustomButtonService), i0.ɵɵdirectiveInject(i5.ToastrService)); };
CustomButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomButtonComponent, selectors: [["custom-button"]], inputs: { inputData: "inputData", inputParams: "inputParams", group: "group" }, decls: 10, vars: 10, consts: [[1, "col-md-4"], [1, "form-check"], [1, "my-3"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "common-bene-class-for-translation"], ["key", "selectOs", "appendTo", "body", "header", "Download E-File Tracker Application", 1, "download", 3, "visible", "visibleChange"], ["os", ""], ["pTemplate", "content"], ["pTemplate", "footer"], [1, "row"], [1, "col"], [1, "col-12"], ["name", "os", "label", "", "value", "unix", 1, "mr-2", 3, "ngModel", "ngModelChange"], ["for", "unix", 1, "common-bene-class-for-translation"], ["name", "os", "value", "windows", 3, "ngModel", "ngModelChange"], ["for", "windows", 1, "mt-1", "common-bene-class-for-translation"], ["type", "button", "pButton", "", "icon", "pi pi-times", 3, "click"], ["type", "button", "pButton", "", "icon", "pi pi-check", 3, "click"]], template: function CustomButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function CustomButtonComponent_Template_button_click_3_listener() { return ctx.performAction(); });
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "p-dialog", 5, 6);
        i0.ɵɵlistener("visibleChange", function CustomButtonComponent_Template_p_dialog_visibleChange_6_listener($event) { return ctx.showDownloadInstaller = $event; });
        i0.ɵɵtemplate(8, CustomButtonComponent_ng_template_8_Template, 22, 2, "ng-template", 7);
        i0.ɵɵtemplate(9, CustomButtonComponent_ng_template_9_Template, 6, 0, "ng-template", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(7, _c0, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.disableBtn);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.inputParams.label);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(9, _c1));
        i0.ɵɵproperty("visible", ctx.showDownloadInstaller);
    } }, directives: [i6.Dialog, i1$1.PrimeTemplate, i7.RadioButton, i8.NgControlStatus, i8.NgModel, i9.ButtonDirective], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomButtonComponent, [{
        type: Component,
        args: [{
                selector: 'custom-button',
                templateUrl: 'custom-button.component.html',
                styleUrls: ['custom-button.component.scss'
                ]
            }]
    }], function () { return [{ type: i1$1.ConfirmationService }, { type: i2.Store }, { type: i3.AppServicesLibraryService }, { type: CustomButtonService }, { type: i5.ToastrService }]; }, { inputData: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class CustomButtonModule {
}
CustomButtonModule.ɵfac = function CustomButtonModule_Factory(t) { return new (t || CustomButtonModule)(); };
CustomButtonModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomButtonModule });
CustomButtonModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomButtonModule, { declarations: [CustomButtonComponent], imports: [PrimengLibraryModule], exports: [CustomButtonComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomButtonComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [CustomButtonComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomButtonComponent, CustomButtonModule, CustomButtonService };
//# sourceMappingURL=custom-button.js.map
